import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit exemplar — the floor-tile convention: a 1x1 m slab exactly
// 0.06 thick (top surface at y = 0.06), so any floor tile seats seamlessly
// against any other floor, path or road tile of the kit.
const OAK = "#c8975a";
const OAK_DARK = "#b3814a";

export const floorWood = defineModel({
  id: "floor-wood",
  batchId: "modern",
  name: "Wood floor",
  tags: ["modern", "interior", "structure", "floor", "wood"],
  summary: "A 1x1 oak plank floor tile.",
  description:
    "A one-tile oak floor slab of the Modern Living kit: exactly 1x1 m and " +
    "0.06 m thick, tiling seamlessly with every other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    const planks: Part[] = [];
    // Alternate plank tones as thin overlays on the slab top.
    for (let i = 0; i < 2; i++) {
      planks.push({
        geometry: new THREE.BoxGeometry(1.0, 0.012, 0.2),
        color: OAK_DARK,
        position: [0, 0.06, -0.3 + i * 0.6],
      });
    }
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: OAK, position: [0, 0.03, 0] },
      ...planks,
    ];
  },
  animations: [],
});
